import type { AxiosRequestHeaders } from "axios"
// import { isDebounceTimeOver, isJwtExpiring } from "@/utils/auth"
import axios from "axios"
import { useAuthStore } from "@/stores/auth"
import { useLocalesStore } from "@/stores/i18n"
import { toBoolean } from "@/utils/formatter"

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
const HUB_ROOT = import.meta.env.VITE_HUB_ROOT
const API_ROOT = import.meta.env.VITE_API_ROOT
const STATIC_ROOT = import.meta.env.VITE_STATIC_ROOT
const API_BYPASS_THROTTLE = toBoolean(import.meta.env.VITE_API_BYPASS_THROTTLE)

const HttpClient = axios.create({
	baseURL: API_BASE_URL
})

/*
const __TOKEN_EXPIRATION_THRESHOLD: number = 60 * 5 // 5 minuti
let __TOKEN_REFRESHING = false
let __TOKEN_LAST_CHECK: Date | null = null
*/

HttpClient.interceptors.request.use(
	config => {
		const authStore = useAuthStore()
		const localesStore = useLocalesStore()

		if (!config.headers) config.headers = {} as AxiosRequestHeaders

		if (authStore.fingerprint) {
			config.headers.fingerprint = authStore.fingerprint
		}

		if (authStore.userToken) {
			config.headers.token = authStore.userToken
		}

		if (authStore.userMedicalCenter) {
			config.headers["medical-center"] = authStore.userMedicalCenter
		}

		if (API_BYPASS_THROTTLE) {
			config.headers["bypass-throttle"] = 1
		}

		/*
		if (
			isJwtExpiring(authStore.userToken, __TOKEN_EXPIRATION_THRESHOLD) &&
			!__TOKEN_REFRESHING &&
			isDebounceTimeOver(__TOKEN_LAST_CHECK)
		) {
			__TOKEN_REFRESHING = true
			__TOKEN_LAST_CHECK = new Date()

			authStore.refreshToken().then(() => {
				__TOKEN_REFRESHING = false
			})
		}
		*/

		config.headers.lang = localesStore.locale

		return config
	},
	error => Promise.reject(error)
)

HttpClient.interceptors.response.use(
	response => response,
	error => {
		if (error.status === 401) {
			if (!window.location.pathname.includes("login")) {
				window.location.replace("/logout")
			}
		}

		return Promise.reject(error)
	}
)

export { API_BASE_URL, API_ROOT, HttpClient, HUB_ROOT, STATIC_ROOT }
